<template>
  <div class="flex gap-8 bg-neutral-50 px-8 text-lg overflow-x-auto">
    <button
      v-for="menuItem of menuItems"
      :class="[
        'border-b-2 py-2 whitespace-nowrap',
        menuItem.active
          ? 'border-primary-500 text-primary-500'
          : 'border-neutral-100',
      ]"
      @click="openPage(menuItem.page)"
    >
      {{ menuItem.title }}
    </button>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { $t } from "@teachino/shared-i18n";
import { useGlobalDependencyProvider } from "@teachino/shared-util";

type PageType = 'content' | 'students' | 'ai-settings' | 'settings';
type MenuItem = {
  page: PageType;
  title: string;
  active: boolean;
};
const props = defineProps<{ courseId: string; page: PageType }>();


const menuItems = computed<MenuItem[]>(() => {
  const _menuItems: MenuItem[] = [];
  _menuItems.push({
    page: 'content',
    title: $t('course.plan'),
    active: props.page === 'content',
  });
  _menuItems.push({
    page: 'students',
    title: $t('course_students.share.title'),
    active: props.page === 'students',
  });
  _menuItems.push({
    page: 'ai-settings',
    title: $t('ai_setting.curriculum'),
    active: props.page === 'ai-settings',
  });
  _menuItems.push({
    page: 'settings',
    title: $t('course.settings'),
    active: props.page === 'settings',
  });
  return _menuItems;
});

function openPage(newPage: PageType) {
  navigateTo(`/course/${props.courseId}/${newPage}`);
}
</script>
